import React from 'react';
import { useApiUrl } from '../../../../../../global/config/useApiUrl';
import { useCampfireFetch } from '../../../../../../global/network/useCampfireFetch';

export type FieldValueSource = 'reporting' | 'tasks' | 'forms';

export interface FieldValueField {
  fieldId: string;
  name: string;
  type: string;
  groupId: string | null;
  groupName: string | null;
  options: { id: string; name: string }[];
}

export type FieldValueFields = { [source in FieldValueSource]: FieldValueField[] };

export const EMPTY_FIELD_VALUE_FIELDS: FieldValueFields = { reporting: [], tasks: [], forms: [] };

const YES_NO_OPTIONS = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

const YES_NO_TYPES = ['yes_no', 'boolean'];
const OPTION_TYPES = ['dropdown', 'multiple_choice', 'checkbox'];

export const isFieldValueTarget = (tag: string, name: string) =>
  (tag === 'reporting' && name === 'report-field-value') ||
  (['tasks', 'forms'].includes(tag) && name === 'field-value');

export const getFieldOptions = (source: FieldValueSource | null, field?: FieldValueField) => {
  if (!field) {
    return [];
  }

  if (YES_NO_TYPES.includes(field.type) || (source === 'reporting' && field.type === 'checkbox')) {
    return YES_NO_OPTIONS;
  }

  return OPTION_TYPES.includes(field.type) ? field.options : [];
};

export const useFieldValueFields = () => {
  const apiUrl = useApiUrl();
  const fieldsQuery = useCampfireFetch<FieldValueFields>({ defer: true });
  const [fields, setFields] = React.useState<FieldValueFields>(EMPTY_FIELD_VALUE_FIELDS);

  React.useEffect(() => {
    fieldsQuery.run({ url: `${apiUrl}/vm/dashboard/management/field-value-options` }).then((response) => {
      if (response.data?.data) {
        setFields(response.data.data);
      }
    });
  }, []);

  return fields;
};
